// Validated with the dataviz palette validator against our white card surface.
// Lives in its own file rather than utils/index.js so the existing
// chartsColorsTheme export - which other pages consume - is left untouched.
//
//   sequential  ALL PASS  monotone lightness, adjacent dL >= 0.06, single hue (16 deg)
//   series      ALL PASS  CVD dE 30.8, normal-vision dE 37.8, both >= 3:1 on white
//
// Values are theme tokens from themes/theme.js: b75, b100, b200, b300, b400.
// purple_dark is deliberately excluded - it collides with b200 (dL 0.016).
// #eb6834 is the only non-theme value; the brand ramps offer no hue far enough
// from purple for a second series, and red and yellow are reserved for status.
export const CHART_PALETTE = {
  sequential: ['#ada2ed', '#8c7ce6', '#5a43db', '#381dd4', '#271494'],
  series: ['#5a43db', '#eb6834'],
  // Bars share one hue: the bar's length already encodes magnitude, so varying
  // hue per bar would be decorative. The ramp is used for nested sector rows.
  bar: '#5a43db',
};

const EM_DASH = '—';

// Direction is carried by an arrow glyph as well as tone, so meaning survives
// without color for the ~8% of men with colour vision deficiency.
export function formatDelta(deltaPct, higherIsBetter) {
  if (deltaPct === null || deltaPct === undefined || Number.isNaN(deltaPct)) {
    return { text: EM_DASH, direction: 'flat', tone: 'neutral' };
  }
  if (deltaPct === 0) return { text: '0%', direction: 'flat', tone: 'neutral' };

  const rising = deltaPct > 0;
  const isGood = rising === Boolean(higherIsBetter);
  return {
    text: `${Math.abs(deltaPct)}%`,
    direction: rising ? 'up' : 'down',
    tone: isGood ? 'good' : 'bad',
  };
}

export function formatCount(value) {
  if (value === null || value === undefined || Number.isNaN(value)) return EM_DASH;
  if (Math.abs(value) < 1000) return String(value);
  if (Math.abs(value) < 1000000) return `${Math.round((value / 1000) * 10) / 10}K`;
  return `${Math.round((value / 1000000) * 10) / 10}M`;
}
